import { gql } from '@apollo/client';

export const getSitesTotal = gql`
  query getSitesTotal {
    listSites {
      total
    }
  }
`;
